export default __webpack_public_path__ + "static/media/broken-link.1047cc2e.png";